import { useEffect, useState } from "react";

export const useGetEnvironment = (productionHostNames: string[]) => {
    const [environment, setEnvironment] = useState<
        "production" | "development" | "unknown"
    >("unknown");

    useEffect(() => {
        const result = productionHostNames.includes(window.location.host);
        setEnvironment(result ? "production" : "development");
    }, []);

    return environment;
};
